// ./contect/authAction.js

export default (type, payload) => dispatch => {
    
    if(type === 'LOGOUT' || type === 'FIRST_LOAD'){
        // Clear token from storage
        // localStorage.removeItem('user');
        localStorage.removeItem('userInfo');
        localStorage.removeItem('userRole');
        localStorage.removeItem('googleToken');
        console.log("User information is removed");
        dispatch({
            type
        })
    }
    
    else if(type === 'LOGIN_SUCCESS'){
        dispatch({
            type,
            payload
        })
    } 
    
    else if (type === 'UPDATE') {
        dispatch({ type: 'UPDATE', payload });
    }

}